import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-064e03e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "w-full text-center relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-blue-500 text-white font-semibold p-3 mb-0 border-b border-solid border-slate-100 uppercase rounded-t-lg" }, " Project Creation "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white p-3" }, " Start a Project Now for Efficient Management and Analysis of Your Audio Files. ")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, " Choose a name for your project and start organizing your tasks! ")
], -1))
const _hoisted_6 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectCreationForm = _resolveComponent("ProjectCreationForm")!
  const _component_ModalButton = _resolveComponent("ModalButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'neon-shadow': _ctx.shockwaveActivated && !_ctx.hasProjects })
  }, [
    _createVNode(_component_ModalButton, null, {
      button: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              ref: "btnRef",
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTooltip())),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip())),
              class: "outline-none focus:outline-none ease-linear transition-all duration-150 btn--shockwave",
              type: "button"
            }, " Create Project ", 544),
            _createElementVNode("div", {
              ref: "tooltipRef",
              class: _normalizeClass([{ 'hidden': !_ctx.tooltipShow, 'block': _ctx.tooltipShow }, "absolute top-9 right-full ml-3 bg-blue-400 border-0 z-50 w-96 font-normal leading-normal text-sm max-w-md text-left no-underline break-words rounded-lg"])
            }, _hoisted_4, 2)
          ])
        ])
      ]),
      modalTitle: _withCtx(() => [
        _createTextVNode("Create a new project")
      ]),
      modalContent: _withCtx(() => [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ProjectCreationForm, { onProject: _ctx.projectCreated }, null, 8, ["onProject"])
        ])
      ]),
      _: 1
    })
  ], 2))
}